var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { class: [{ "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }] },
    [
      _c(
        "div",
        {
          staticClass: "navigation-colum logo-section",
          on: { click: _vm.toggleSideMenu }
        },
        [
          _c("div", { staticClass: "sidemenu-controls" }, [
            _c("div", { staticClass: "mod burger" }, [
              _c("div", { ref: "burger", staticClass: "menu" }, [
                _c("div", {
                  class: [
                    "bar",
                    { "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }
                  ]
                }),
                _c("div", {
                  class: [
                    "bar",
                    { "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }
                  ]
                }),
                _c("div", {
                  class: [
                    "bar",
                    { "dark-blue-mode": _vm.$route.meta.headerColor === "dark" }
                  ]
                })
              ])
            ])
          ])
        ]
      ),
      _c(
        "div",
        { staticClass: "header-wrapper" },
        [
          _c(
            "div",
            { staticClass: "logo-container" },
            [
              _vm.$route.path !== "/landing"
                ? _c(
                    "router-link",
                    {
                      staticClass: "logo",
                      attrs: {
                        tag: "div",
                        to: `${
                          !_vm.$route.fullPath.includes("/gop/")
                            ? "/home"
                            : "/gop/home"
                        }`
                      }
                    },
                    [
                      !_vm.$route.fullPath.includes("/gop/")
                        ? _c("img", {
                            attrs: {
                              src:
                                _vm.$route.meta.headerColor === "dark"
                                  ? require("@/drc/assets/images/dark-mode-logo.svg")
                                  : require("@/common/assets/icons/drc-logo.svg"),
                              alt: "Akkodis"
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("@/common/assets/icons/gop-logo.svg"),
                              alt: "GOP"
                            }
                          })
                    ]
                  )
                : _c("div", { staticClass: "logo akkodis-logo" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/common/assets/icons/akkodis-brand-logo.svg"),
                        alt: "Akkodis"
                      }
                    })
                  ])
            ],
            1
          ),
          _c("HeaderGlobalSearch", {
            attrs: { latestProjects: _vm.latestProjects }
          }),
          _c(
            "div",
            { staticClass: "language-and-profile-container" },
            [
              _vm.showLanguageOptions
                ? _c("ApplicationLanguageDropdown")
                : _vm._e(),
              _c("UserProfile")
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }